import { IContactInfo, IEmployeeStatus, IObjectAudit } from "../../../models"
import { IOccupation } from "../../data/HR/Credentials/Occupation"
import { ISpecialty } from "../../data/HR/Credentials/Specialty"
import { IStatusDetails } from "../../data/StatusDetails"
import { IBadge } from "../../data/workflow/Badge"
import { IUserDocument } from "../UserDocument"

export type EmergencyContact = {
    ContactInfo?: IContactInfo
    Name?: string
    Relationship?: string
} & {
    [key: string]: any
}

export type EmployeeStatus = {
    Id?: string
    ExternalId?: string
    Name?: string
    EmployeeSubStatus?: EmployeeSubStatus
    Type?: string
    Description?: string
    SortOrder?: number
    System?: boolean
    Details?: IStatusDetails
    SubStatuses?: Array<EmployeeSubStatus>
    ObjectAudit?: ObjectAudit
    IsTerminated?: boolean
    TLMActive?: boolean
    Active?: boolean
    TicksSinceChange?: number
    Deleted?: boolean
} & {
    [key: string]: any
}

export type ObjectAudit = {
    Completed?: boolean
    CompletedDate?: string
    CompletedByName?: string
    CompletedByUserId?: string
    CompletedByS3Signature?: string
    CreatedDate?: string
    CreatedByName?: string
    CreatedByUserId?: string
    CreatedByAvatarS3URL?: string
    LastModified?: string
    LastModifiedByName?: string
    LastModifiedByUserId?: string
    LastModifiedByAvatarS3URL?: string
    Verified?: boolean
    VerifiedDateTime?: string
    VerifiedByName?: string
    VerifiedS3Signature?: string
} & {
    [key: string]: any
}

export type EmployeeSubStatus = {
    Id?: string
    ExternalId?: string
    Description?: string
    SortOrder?: number
    System?: boolean
    Name?: string
    Active?: boolean
    TicksSinceChange?: number
    Deleted?: boolean
    ObjectAudit?: ObjectAudit
} & {
    [key: string]: any
}

export type Resume = {
    Text?: string
    HTML?: string
} & {
    [key: string]: any
}

export type BadgeFulfillmentSummary = {
    TotalRequirments?: number
    TotalCompleted?: number
    Percentage?: number
    CompletedItems?: Array<BadgeItemSummary>
    UnCompletedItems?: Array<BadgeItemSummary>
} & {
    [key: string]: any
}

export type BadgeItemSummary = {
    Category?: string
    SubType?: string
    Completed?: boolean
    CompletedDate?: string
} & {
    [key: string]: any
}

export type IEmployeeHRDocument = {
    Id?: string
    EmployeeId?: string
    UserId?: string
    AccountId?: string
    HierarchyId?: string
    AlternateEmail?: string
    MiddleName?: string
    MaidenName?: string
    PreferredName?: string
    DisplayFirstName?: string
    Source?: string
    ReferralSourceId?: string
    ReferralSourceName?: string
    PermanentContactInfo?: IContactInfo
    PermanentContactInfoHistory?: Array<IContactInfo>
    TemporaryContactInfo?: IContactInfo
    TemporaryContactInfoHistory?: Array<IContactInfo>
    EmergencyContact?: EmergencyContact
    DateOfBirth?: string
    MaritalStatus?: string
    Gender?: string
    PreferredPronoun?: string
    Citizenship?: string
    Race?: string
    ApplicationDate?: string
    OriginalHireDate?: string
    LatestTerminationDate?: string
    SeniorityDate?: string
    DateStarted?:string
    RehireDates?: Array<string>
    TerminationDates?: Array<string>
    Terminated?: boolean
    Status?: IEmployeeStatus
    ObjectAudit?: IObjectAudit
    TicksSinceChange?: number
    Deleted?: boolean
    UDF?: {} & {
        [key: string]: {} & {
            [key: string]: any
        }
    }
    Resume?: Resume
    YearsExperience?: string
    ApplicationVerified?: boolean
    Occupation?: IOccupation
    PrimarySpecialty?: ISpecialty
    Specialties?: Array<ISpecialty>
    User?: IUserDocument
    Badges?: Array<IBadge>
    CatchAll?: {} & {
        [key: string]: {} & {
            [key: string]: any
        }
    }
    PrimaryLanguage?: string
    Languages?: Array<string>
    ReferredByWhom?: string
} & {
    [key: string]: any
}

export enum EMaritalStatus {
    Married = 0,
    Single = 1
}

export enum EGender {
    Male = 0,
    Female = 1,
    Other = 2
}
